import { RESIDENT_CARE_PLAN_TYPE } from "./constants";
import { BODY_CHART_CARE_PLAN_TYPE } from "./carePlanBodyChart";

export const DEFAULT_SUMMARY_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.SUMMARY,
    "acesId": "",
    "anyAdvancedDirectives": false,
    "anyDementiaCareNeeds": false,
    "anyDevelopmentalDisabilityCareNeeds": false,
    "anyLegalDocuments": false,
    "anyMentalHealthCareNeeds": false,
    "anyOtherLegalDocuments": false,
    "anyOtherSpecialtyCareNeeds": false,
    "anyPOLSTForms": false,
    "anySpecialtyCareNeeds": false,
    "dateNCPCompleted": "",
    "dateNCPStarted": "",
    "evacuationAssistanceRequired": false,
    "medicalDiagnosesDetails": "",
    "otherLegalDocumentsDetails": "",
    "otherSpecialtyCareNeedsDetails": "",
    "providerName": "",
    "residentAllergies": "",
    "residentDateOfBirth": "",
    "residentDischargeDate": "",
    "residentEvacuationAndSafetyInstructions": "",
    "residentInterpreterNeeded": false,
    "residentMoveInDate": "",
    "residentPrimaryLanguage": "",
    "residentPronouns": "",
    "residentSpeakEnglish": false,
    "residentName": "",
    "residentAge": "",
}

export const DEFAULT_RESPONSIBLE_PARTIES_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.RESPONSIBLE_PARTIES,
    "collateralContacts": [{ "fullName": "", "relationship": "", "phoneNumber": "", "faxNumber": "", "address": "", "preferredContactMethod": "" }],
    "primaryPhysicianName": "",
    "primaryPhysicianClinic": "",
    "primaryPhysicianPhone": "",
    "primaryPhysicianFax": "",
    "primaryPhysicianEmail": "",
    "primaryPhysicianAddress": "",
    "pharmacyName": "",
    "pharmacyPhone": "",
    "pharmacyFax": "",
    "pharmacyEmail": "",
    "pharmacyAddress": "",
    "preferredHospitalName": "",
    "preferredHospitalPhone": "",
    "preferredHospitalFax": "",
    "preferredHospitalEmail": "",
    "preferredHospitalLocation": "",
    "preferredHospitalPreferredContactMethod": "",
}

export const DEFAULT_COMMUNICATION_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.COMMUNICATION,
    "abilityToUsePhone": "",
    "anyAssistanceRequired": "",
    "anyComments": "",
    "anyStrengthAndAbilities": "",
    "expressionDescribed": "",
    "expressionEquipmentUsed": "",
    "hearingDescribed": "",
    "hearingEquipmentUsed": "",
    "howResidentMakesSelfUnderstood": "",
    "howResidentUnderstandOthers": "",
    "problemWithHearing": false,
    "problemWithModesOfExpression": false,
    "problemWithVision": false,
    "residentPhoneNumber": "",
    "visionDescribed": "",
    "visionEquipmentUsed": ""
}

export const DEFAULT_MEDICATION_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.MEDICATION_MANAGEMENT,
    "allergiesDescribed": "",
    "anyAllergies": false,
    "anyPsychopharmacologicMedication": false,
    "assessmentMedicationListRawText": "",
    "medicalRefusalPlanAssistanceDetails": "",
    "medicalRefusalPlanStrengthDetails": "",
    "medicationAdministeredByStaff": false,
    "medicationAmountReasonableDetails": "",
    "medicationAssistanceDetails": "",
    "medicationEntries": [],
    "medicationManagementTypes": [
    ],
    "medicationPlanOutsideAFHAssistanceDetails": "",
    "medicationPlanOutsideAFHStrengthDetails": "",
    "medicationStrengthsDetails": "",
    "medsDeliveredBy": "",
    "medsOrderedBy": "",
    "medsPharmacyPacked": false,
    "medsPharmacyPackedDetails": "",
    "needMoreThanOneMedication": false,
    "nurseDelegationContact": "",
    "seeMARForMedicationDetails": false,
    "selfAdministerMedications": false,
    "selfAdministerMedicationsWithAssistance": false
}

export const DEFAULT_HEALTH_INDICATOR_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.HEALTH_INDICATORS,
    "allergyReactionDetails": "",
    "allergySubstanceDetails": "",
    "anyAllergies": false,
    "anyHospitalizations": false,
    "anyHospitalizationsAssistanceDetails": "",
    "anyHospitalizationsStrengthDetails": "",
    "anyOtherHealthIndicatorsAssistanceDetails": "",
    "anyOtherHealthIndicatorsDetails": "",
    "anyOtherHealthIndicatorsStrengthDetails": "",
    "anyPain": false,
    "anyPainAssistanceDetails": "",
    "anyPainStrengthDetails": "",
    "anyVitalSignAssistanceDetails": "",
    "anyVitalSignIssues": false,
    "anyVitalSignStrengthDetails": "",
    "anyWeightAssistanceDetails": "",
    "anyWeightChanges": false,
    "anyWeightStrengthDetails": "",
    "currentHeight": "",
    "currentWeight": "",
}

export const DEFAULT_PSYCH_SOCIAL_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.PSYCH_SOCIAL_COGNITIVE,
    "anxietyAssistanceDetails": "",
    "anxietyDetails": "",
    "anyAnxiety": false,
    "anyAssaultiveBehavior": false,
    "anyBehavioralHealthSupportCrisisPlan": false,
    "anyBreakThings": false,
    "anyCounselingFromMentalHealthProfessional": false,
    "anyDelusions": false,
    "anyDepression": false,
    "anyDifficultyInNewSituations": false,
    "anyDisorientation": false,
    "anyDisrobing": false,
    "anyDisruptiveBehavior": false,
    "anyExitSeekingBehavior": false,
    "anyExpandedCommunityServices": false,
    "anyHallucinations": false,
    "anyImpairedDecisionMaking": false,
    "anyInappropriateBehavior": false,
    "anyInappropriateSpitting": false,
    "anyIrritability": false,
    "anyLongTermMemoryIssues": false,
    "anyMeaningfulDayInterventions": false,
    "anyMeaningfulDayProgram": false,
    "anyMentalHealthProgram": false,
    "anyNightTimeAssistance": false,
    "anyOrientedToPerson": false,
    "anyOtherInterventions": false,
    "anyOtherPsychSocialCognitiveIssues": false,
    "anyPastBehaviors": false,
    "anyPhysicalAggression": false,
    "anyPsychopharmacologicMedications": false,
    "anyResistanceToCare": false,
    "anyShortTermMemoryIssues": false,
    "anySleepDisturbances": false,
    "anySpecializedBehavioralPrograms": false,
    "anySuicidalBehavior": false,
    "anyUnawareOfConsequences": false,
    "anyUnrealisticFears": false,
    "anyVerbalAggression": false,
    "anyWandering": false,
    "anyWeeping": false,
    "assaultiveBehaviorAssistanceDetails": "",
    "assaultiveBehaviorDetails": "",
    "behavioralHealthSupportCrisisPlanAssistanceDetails": "",
    "behavioralHealthSupportCrisisPlanDetails": "",
    "breakThingsAssistanceDetails": "",
    "breakThingsDetails": "",
    "counselingFromMentalHealthProfessionalAssistanceDetails": "",
    "counselingFromMentalHealthProfessionalDetails": "",
    "delusionsAssistanceDetails": "",
    "delusionsDetails": "",
    "depressionAssistanceDetails": "",
    "depressionDetails": "",
    "difficultyInNewSituationsAssistanceDetails": "",
    "difficultyInNewSituationsDetails": "",
    "disorientationAssistanceDetails": "",
    "disorientationDetails": "",
    "disrobingAssistanceDetails": "",
    "disrobingDetails": "",
    "disruptiveBehaviorAssistanceDetails": "",
    "disruptiveBehaviorDetails": "",
    "exitSeekingBehaviorAssistanceDetails": "",
    "exitSeekingBehaviorDetails": "",
    "expandedCommunityServicesAssistanceDetails": "",
    "expandedCommunityServicesDetails": "",
    "hallucinationsAssistanceDetails": "",
    "hallucinationsDetails": "",
    "impairedDecisionMakingAssistanceDetails": "",
    "impairedDecisionMakingDetails": "",
    "inappropriateBehaviorAssistanceDetails": "",
    "inappropriateBehaviorDetails": "",
    "inappropriateSpittingAssistanceDetails": "",
    "inappropriateSpittingDetails": "",
    "irritabilityAssistanceDetails": "",
    "irritabilityDetails": "",
    "longTermMemoryIssuesAssistanceDetails": "",
    "longTermMemoryIssuesDetails": "",
    "meaningfulDayInterventionsAssistanceDetails": "",
    "meaningfulDayInterventionsDetails": "",
    "meaningfulDayProgramAssistanceDetails": "",
    "meaningfulDayProgramDetails": "",
    "mentalHealthProgramAssistanceDetails": "",
    "mentalHealthProgramContactInfo": "",
    "mentalHealthProgramDetails": "",
    "nightTimeAssistanceAssistanceDetails": "",
    "nightTimeAssistanceDetails": "",
    "normalDayRoutineDetails": "",
    "orientedToPersonAssistanceDetails": "",
    "orientedToPersonDetails": "",
    "otherInterventionsAssistanceDetails": "",
    "otherInterventionsDetails": "",
    "otherPsychSocialCognitiveIssuesAssistanceDetails": "",
    "otherPsychSocialCognitiveIssuesDetails": "",
    "pastBehaviorsAssistanceDetails": "",
    "pastBehaviorsDetails": "",
    "physicalAggressionAssistanceDetails": "",
    "physicalAggressionDetails": "",
    "psychopharmacologicMedicationsAssistanceDetails": "",
    "psychopharmacologicMedicationsDetails": "",
    "resistanceToCareAssistanceDetails": "",
    "resistanceToCareDetails": "",
    "shortTermMemoryIssuesAssistanceDetails": "",
    "shortTermMemoryIssuesDetails": "",
    "sleepDisturbancesAssistanceDetails": "",
    "sleepDisturbancesDetails": "",
    "specializedBehavioralProgramsAssistanceDetails": "",
    "specializedBehavioralProgramsDetails": "",
    "suicidalBehaviorAssistanceDetails": "",
    "suicidalBehaviorDetails": "",
    "unawareOfConsequencesAssistanceDetails": "",
    "unawareOfConsequencesDetails": "",
    "unrealisticFearsAssistanceDetails": "",
    "unrealisticFearsDetails": "",
    "verbalAggressionAssistanceDetails": "",
    "verbalAggressionDetails": "",
    "wanderingAssistanceDetails": "",
    "wanderingDetails": "",
    "weepingAssistanceDetails": "",
    "weepingDetails": ""
}

export const DEFAULT_LEFT_ALONE_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.LEFT_ALONE_STATUS,
    "leftAloneAssistanceDetails": "",
    "leftAloneDetails": "",
}

export const DEFAULT_ACTIVITY_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.ACTIVITIES_OF_DAILY_LIVING,
    "anyBathingEquipmentUsed": false,
    "anyBathingLimitations": false,
    "anyBladderContinenceIssues": false,
    "anyBowelContinenceIssues": false,
    "anyBrushing": false,
    "anyDiabeticFootCare": false,
    "anyDressingChanges": false,
    "anyDressingEquipmentUsed": false,
    "anyDressingLimitations": false,
    "anyEatingEquipmentUsed": false,
    "anyEatingHabits": false,
    "anyEatingLimitations": false,
    "anyEquipmentUsedForMobility": false,
    "anyFallPreventionPlan": false,
    "anyFallRisks": false,
    "anyFlossing": false,
    "anyFoodAllergies": false,
    "anyFootCare": false,
    "anyFootCareEquipmentUsed": false,
    "anyFootCareHomeHealthAgency": false,
    "anyFootCareLimitations": false,
    "anyHairCare": false,
    "anyHygieneEquipmentUsed": false,
    "anyHygieneLimitations": false,
    "anyInBedEquipmentOrSupplies": false,
    "anyInBedFallPreventionSafetyPlan": false,
    "anyInBedMedicalDeviceAssessment": false,
    "anyInBedMedicalDevices": false,
    "anyInBedMedicalEnablers": false,
    "anyInBedMedicalHoyerLifts": false,
    "anyInBedMedicalTransferPole": false,
    "anyInBedNightTimeCare": false,
    "anyInBedRiskForFallSafetyPlan": false,
    "anyInBedSafetyPlan": false,
    "anyInBedSafetyPrecautions": false,
    "anyInBedSkinCare": false,
    "anyInBedTurningAndRepositioning": false,
    "anyLimitationsInMobility": false,
    "anyMensesCare": false,
    "anyNailCare": false,
    "anyNurseDelegationForSkinCare": false,
    "anyOralHygieneCare": [
    ],
    "anyPressureInjuries": false,
    "anySkinCareDueToBowelIncontinence": false,
    "anySkinCareEquipmentUsed": false,
    "anySkinCareHomeHealthAgency": false,
    "anySkinCareLimitations": false,
    "anySkinProblems": false,
    "anySoaking": false,
    "anySpecialDietaryNeeds": false,
    "anyToiletingEquipmentUsed": false,
    "anyToiletingLimitations": false,
    "bathingAssistanceRequired": "",
    "bathingDetails": "",
    "bathingEquipmentUsedAssistanceRequired": "",
    "bathingEquipmentUsedDetails": "",
    "bathingFrequencyAssistanceRequired": "",
    "bathingFrequencyDetails": "",
    "bathingLimitationsAssistanceRequired": "",
    "bathingLimitationsDetails": "",
    "bedMobilityAssistanceRequired": "",
    "bedMobilityDetails": "",
    "bladderContinenceIssuesAssistanceRequired": "",
    "bladderContinenceIssuesDetails": "",
    "bowelContinenceIssuesAssistanceRequired": "",
    "bowelContinenceIssuesDetails": "",
    "brushingAssistanceRequired": "",
    "brushingDetails": "",
    "diabeticFootCareAssistanceRequired": "",
    "diabeticFootCareDetails": "",
    "doesEvacuationAddressedInEvacuationPlan": false,
    "doesResidentChooseDoorLocks": false,
    "doorLocksAssistanceRequired": "",
    "doorLocksDetails": "",
    "dressingAssistanceRequired": "",
    "dressingChangesAssistanceRequired": "",
    "dressingChangesDetails": "",
    "dressingDetails": "",
    "dressingEquipmentUsedAssistanceRequired": "",
    "dressingEquipmentUsedDetails": "",
    "dressingLimitationsAssistanceRequired": "",
    "dressingLimitationsDetails": "",
    "eatingBehaviorAssistanceRequired": "",
    "eatingBehaviorDetails": "",
    "eatingEquipmentUsedAssistanceRequired": "",
    "eatingEquipmentUsedDetails": "",
    "eatingHabitsAssistanceRequired": "",
    "eatingHabitsDetails": "",
    "eatingLimitationsAssistanceRequired": "",
    "eatingLimitationsDetails": "",
    "equipmentUsedForMobilityAssistanceRequired": "",
    "equipmentUsedForMobilityDetails": "",
    "equipmentVendorDetails": "",
    "fallPreventionPlanAssistanceRequired": "",
    "fallPreventionPlanDetails": "",
    "fallRisksAssistanceRequired": "",
    "fallRisksDetails": "",
    "flossingAssistanceRequired": "",
    "flossingDetails": "",
    "foodAllergiesAssistanceRequired": "",
    "foodAllergiesDetails": "",
    "footCareAssistanceRequired": "",
    "footCareDetails": "",
    "footCareEquipmentUsedAssistanceRequired": "",
    "footCareEquipmentUsedDetails": "",
    "footCareFrequencyAssistanceRequired": "",
    "footCareFrequencyDetails": "",
    "footCareHomeHealthAgencyDetails": "",
    "footCareLimitationsAssistanceRequired": "",
    "footCareLimitationsDetails": "",
    "hairCareAssistanceRequired": "",
    "hairCareDetails": "",
    "hygieneEquipmentUsedAssistanceRequired": "",
    "hygieneEquipmentUsedDetails": "",
    "hygieneFrequencyAssistanceRequired": "",
    "hygieneFrequencyDetails": "",
    "hygieneLimitationsAssistanceRequired": "",
    "hygieneLimitationsDetails": "",
    "inBedEquipmentOrSuppliesAssistanceRequired": "",
    "inBedEquipmentOrSuppliesDetails": "",
    "inBedFallPreventionSafetyPlanAssistanceRequired": "",
    "inBedFallPreventionSafetyPlanDetails": "",
    "inBedMedicalDeviceAssessmentAssistanceRequired": "",
    "inBedMedicalDeviceAssessmentDetails": "",
    "inBedMedicalDevicesAssistanceRequired": "",
    "inBedMedicalDevicesDetails": "",
    "inBedMedicalEnablersAssistanceRequired": "",
    "inBedMedicalEnablersDetails": "",
    "inBedMedicalHoyerLiftsAssistanceRequired": "",
    "inBedMedicalHoyerLiftsDetails": "",
    "inBedMedicalTransferPoleAssistanceRequired": "",
    "inBedMedicalTransferPoleDetails": "",
    "inBedNightTimeCareAssistanceRequired": "",
    "inBedNightTimeCareDetails": "",
    "inBedRiskForFallSafetyPlanAssistanceRequired": "",
    "inBedRiskForFallSafetyPlanDetails": "",
    "inBedSafetyPlanAssistanceRequired": "",
    "inBedSafetyPlanDetails": "",
    "inBedSafetyPrecautionsAssistanceRequired": "",
    "inBedSafetyPrecautionsDetails": "",
    "inBedSkinCareAssistanceRequired": "",
    "inBedSkinCareDetails": "",
    "inBedTurningAndRepositioningAssistanceRequired": "",
    "inBedTurningAndRepositioningDetails": "",
    "limitationsInMobilityAssistanceRequired": "",
    "limitationsInMobilityDetails": "",
    "mensesCareAssistanceRequired": "",
    "mensesCareDetails": "",
    "movementOutsideFacilityAssistanceRequired": "",
    "movementOutsideFacilityDetails": "",
    "movementWithinFacilityAssistanceRequired": "",
    "movementWithinFacilityDetails": "",
    "nailCareAssistanceRequired": "",
    "nailCareDetails": "",
    "nurseDelegationForSkinCareContact": "",
    "nurseDelegationForSkinCareDetails": "",
    "oralHygieneCareAssistanceRequired": "",
    "oralHygieneCareDetails": "",
    "personalHygieneAssistanceRequired": "",
    "personalHygieneDetails": "",
    "pressureInjuriesAssistanceRequired": "",
    "pressureInjuriesDetails": "",
    "skinCareAssistanceRequired": "",
    "skinCareDetails": "",
    "skinCareDueToBowelIncontinenceAssistanceRequired": "",
    "skinCareDueToBowelIncontinenceDetails": "",
    "skinCareEquipmentUsedAssistanceRequired": "",
    "skinCareEquipmentUsedDetails": "",
    "skinCareFrequencyAssistanceRequired": "",
    "skinCareFrequencyDetails": "",
    "skinCareHomeHealthAgencyDetails": "",
    "skinCareLimitationsAssistanceRequired": "",
    "skinCareLimitationsDetails": "",
    "skinProblemsAssistanceRequired": "",
    "skinProblemsDetails": "",
    "soakingAssistanceRequired": "",
    "soakingDetails": "",
    "specialDietaryNeedsAssistanceRequired": "",
    "specialDietaryNeedsDetails": "",
    "teethType": "",
    "teethTypeAssistanceRequired": "",
    "teethTypeDetails": "",
    "toiletFrequencyAssistanceRequired": "",
    "toiletFrequencyDetails": "",
    "toiletHandlingAssistanceRequired": "",
    "toiletHandlingDetails": "",
    "toiletingEquipmentUsedAssistanceRequired": "",
    "toiletingEquipmentUsedDetails": "",
    "toiletingLimitationsAssistanceRequired": "",
    "toiletingLimitationsDetails": "",
    "typeOfBathing": "",
    "typeOfBedMobility": "",
    "typeOfDressing": "",
    "typeOfEatingBehavior": "",
    "typeOfFootCare": "",
    "typeOfMovementOutsideFacility": "",
    "typeOfMovementWithinFacility": "",
    "typeOfPersonalHygiene": "",
    "typeOfSkinCare": "",
    "typeOfToiletHandling": ""
}

export const DEFAULT_INSTRUMENTAL_ACTIVITY_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.INSTRUMENTAL_ACTIVITIES_OF_DAILY_LIVING,
    "activitiesAtGlance": [
    ],
    "activityAssistanceRequired": "",
    "activityDetails": "",
    "activityLevel": "",
    "activityNarrative": "",
    "additionalInformation": "",
    "additionalInformationAssistanceRequired": "",
    "anyClubsGroups": false,
    "anyEmploymentSupport": false,
    "anyFamilyFriendsRelationships": false,
    "anyOtherActivities": false,
    "anyParticipationIssues": false,
    "anyPayeeDetails": false,
    "anyReligiousActivities": false,
    "anyShoppingEquipmentNeeds": false,
    "anyShoppingLimitations": false,
    "anySmokingPolicySigned": false,
    "anySmokingSafetyConcerns": false,
    "anySocialCulturalActivities": false,
    "anySpecialArrangements": false,
    "anyTransportationEquipmentNeeds": false,
    "anyTransportationEscortNeeds": false,
    "anyTransportationLimitations": false,
    "anyTransportationMedicalNeeds": false,
    "anyWhoManagesFinance": false,
    "anyWhoManagesFinanceAssistanceRequired": "",
    "anyWhoManagesFinanceDetails": "",
    "anyWhoManagesFinancialRecords": false,
    "anyWhoManagesFinancialRecordsAssistanceRequired": "",
    "anyWhoManagesFinancialRecordsDetails": "",
    "caseManagementAssistanceRequired": "",
    "caseManagementDetails": "",
    "caseManagerContactAgency": "",
    "caseManagerContactEmail": "",
    "caseManagerContactFax": "",
    "caseManagerContactName": "",
    "caseManagerContactPhone": "",
    "clubsGroupsAssistanceRequired": "",
    "clubsGroupsDetails": "",
    "conditionsWhenToContactCaseManager": "",
    "doesSmoke": false,
    "emergencyNumbers": "",
    "employmentSupportAssistanceRequired": "",
    "employmentSupportDetails": "",
    "familyFriendsRelationshipsAssistanceRequired": "",
    "familyFriendsRelationshipsDetails": "",
    "manageFinanceAssistanceRequired": "",
    "manageFinanceDetails": "",
    "manageFinanceLevel": "",
    "manageShoppingAssistanceRequired": "",
    "manageShoppingDetails": "",
    "manageShoppingLevel": "",
    "ncpReviewAssistanceRequired": "",
    "ncpReviewDetails": "",
    "otherActivitiesDetails": "",
    "participationIssuesAssistanceRequired": "",
    "participationIssuesDetails": "",
    "payeeDetails": "",
    "receivesCaseManagement": false,
    "religiousActivitiesAssistanceRequired": "",
    "religiousActivitiesDetails": "",
    "shoppingEquipmentAssistanceRequired": "",
    "shoppingEquipmentDetails": "",
    "shoppingFrequencyAssistanceRequired": "",
    "shoppingFrequencyDetails": "",
    "shoppingLimitationsAssistanceRequired": "",
    "shoppingLimitationsDetails": "",
    "smokingAssistanceRequired": "",
    "smokingDetails": "",
    "smokingPolicySignedDetails": "",
    "smokingSafetyConcernsAssistanceRequired": "",
    "smokingSafetyConcernsDetails": "",
    "smokingStorageDetails": "",
    "socialCulturalActivitiesAssistanceRequired": "",
    "socialCulturalActivitiesDetails": "",
    "specialArrangementsAssistanceRequired": "",
    "specialArrangementsDetails": "",
    "specialShoppingTransportationAssistanceRequired": "",
    "specialShoppingTransportationDetails": "",
    "specialShoppingTransportationNeeds": false,
    "specialTransportationAssistanceRequired": "",
    "specialTransportationDetails": "",
    "specialTransportationNeeds": false,
    "transportationEquipmentAssistanceRequired": "",
    "transportationEquipmentDetails": "",
    "transportationEscortAssistanceRequired": "",
    "transportationEscortDetails": "",
    "transportationFrequencyAssistanceRequired": "",
    "transportationFrequencyDetails": "",
    "transportationLimitationsAssistanceRequired": "",
    "transportationLimitationsDetails": "",
    "transportationManageAssistanceRequired": "",
    "transportationManageDetails": "",
    "transportationManageLevel": "",
    "transportationMedicalAssistanceRequired": "",
    "transportationMedicalDetails": ""
}

export const DEFAULT_TREATMENT_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.TREATMENT_PROGRAM_THERAPIES,
    "adultDayHealthProgramsAssistanceDetails": "",
    "adultDayHealthProgramsDetails": "",
    "anyAdultDayHealthPrograms": false,
    "anyAntiCoagulantTherapy": false,
    "anyBloodGlucoseMonitoring": false,
    "anyBloodThinners": false,
    "anyCPAP_BiPAP": false,
    "anyDialysis": false,
    "anyHomeHealthServices": false,
    "anyHospiceAgencyServices": false,
    "anyInjectionUse": false,
    "anyINR_LABMonitoring": false,
    "anyInterventionsForMeaningfullDay": false,
    "anyNebulizerUse": false,
    "anyNurseDelegatedProcedures": false,
    "anyOtherProgramServices": false,
    "anyOtherTreatmentPrograms": false,
    "anyOxygenUse": false,
    "anyPhysicalEnablers": false,
    "anyPT_OT_ST_Therapies": false,
    "anyRangeOfMotionExercises": false,
    "anyTreatmentRefusalPlan": false,
    "bloodGlucoseMonitoringAssistanceDetails": "",
    "bloodGlucoseMonitoringDetails": "",
    "bloodThinnersAssistanceDetails": "",
    "bloodThinnersDetails": "",
    "CPAP_BiPAPAssistanceDetails": "",
    "CPAP_BiPAPDetails": "",
    "dialysisAssistanceDetails": "",
    "dialysisDetails": "",
    "homeHealthServicesAssistanceDetails": "",
    "homeHealthServicesDetails": "",
    "hospiceAgencyServicesAssistanceDetails": "",
    "hospiceAgencyServicesDetails": "",
    "injectionUseAssistanceDetails": "",
    "injectionUseDetails": "",
    "interventionsForMeaningfullDayAssistanceDetails": "",
    "interventionsForMeaningfullDayDetails": "",
    "nebulizerUseAssistanceDetails": "",
    "nebulizerUseDetails": "",
    "nurseDelegatedProceduresAssistanceDetails": "",
    "nurseDelegatedProceduresDetails": "",
    "otherProgramServicesAssistanceDetails": "",
    "otherProgramServicesDetails": "",
    "otherTreatmentProgramsAssistanceDetails": "",
    "otherTreatmentProgramsDetails": "",
    "oxygenUseAssistanceDetails": "",
    "oxygenUseDetails": "",
    "physicalEnablersAssistanceDetails": "",
    "physicalEnablersDetails": "",
    "PT_OT_ST_TherapiesAssistanceDetails": "",
    "PT_OT_ST_TherapiesDetails": "",
    "rangeOfMotionExercisesAssistanceDetails": "",
    "rangeOfMotionExercisesDetails": "",
    "treatmentRefusalPlanAssistanceDetails": "",
    "treatmentRefusalPlanDetails": ""
}

export const DEFAULT_UNIVERSAL_PRECAUTIONS_SECTION = {
    "carePlanType": RESIDENT_CARE_PLAN_TYPE.UNIVERSAL_PRECAUTIONS,
    "alternativeMethodOfVisitationAssistanceRequired": "",
    "alternativeMethodOfVisitationDetails": "",
    "anyAlternativeMethodOfVisitation": false,
    "anyOtherPrecautions": false,
    "anyPrecautionsAlwaysApply": false,
    "anySharedMedicalEquipment": false,
    "anySpecialPrecautions": false,
    "canWearMask": false,
    "maskWearingAssistanceRequired": "",
    "maskWearingDetails": "",
    "otherPrecautionsAssistanceRequired": "",
    "otherPrecautionsDetails": "",
    "precautionsAlwaysApplyAssistanceRequired": "",
    "precautionsAlwaysApplyDetails": "",
    "safeToLeaveSanitizerWithResident": false,
    "sanitizerAssistanceRequired": "",
    "sanitizerDetails": "",
    "sharedMedicalEquipmentAssistanceRequired": "",
    "sharedMedicalEquipmentDetails": "",
    "specialPrecautionsAssistanceRequired": "",
    "specialPrecautionsDetails": "",
    "upToDateWithVaccinations": false,
    "vaccinationsAssistanceRequired": "",
    "vaccinationsDetails": ""
}

export const ASSISTANCE_REQUIRED_MESSAGE = "Assistance Required - Who Will Provide, When, And How";
export const RESIDENT_STRENGTH_MESSAGE = "Resident Strengths And Abilities - Prefers To Do Independently - Preferences and Personal Goals";

const convertListToOptions = (list: string[]) => {
    return list.map(item => {
        return { name: item, value: item }
    });
}

export const SUGGESTED_INSTRUCTIONS_NIGHT_DISRUPTIONS = convertListToOptions([
    "Discourage daytime naps",
    "Limit caffeine to morning hours",
    "Get them a snack or something to drink and assist the client back to bed",
    "Limit stimulus and / or physical activity before bed",
    "Report changes to the client's doctor",
    "Establish a food sleep routine—getting up and going to bed at the same time ever day"
]);


export const SUGGESTED_INSTRUCTIONS_CRYTING = convertListToOptions([
    "Look for signs/of pain/discomfort and respond with appropriate action",
    "Talk to the client and validate about what he / she is feeling",
    "Redirect attention to a TV program, music, or activity client enjoys",
    "Let the client know you are going to walk away and give client alone time. Listen from another room. Re - approach later when the client appears ready.",
    "Report change to the client's doctor"
]);
export const SUGGESTED_INSTRUCTIONS_NON_HEALTH_REPITITIVE_ANXIETY = convertListToOptions([
    "Provide a consistent daily routine",
    "Assist the individual to organize their day",
    "Redirect into the here and now",
    "Explore comfort measures(warm blanket, rocking, etc.)",
    "Report changes to the client's doctor",
    "Use a calendar to track daily activities and routines with the client"
]);
export const SUGGESTED_INSTRUCTIONS_IRRITABLE = convertListToOptions([
    "Avoid changes & surprises and give advance warning as appropriate / possible",
    "Reassure frequently",
    "Slow down and reduce stimulation",
    "Simplify the task or break it into small steps",
    "Assist the client to organize their day",
    "Let the client know you are going to walk away and give client alone time.Listen from another room.Re - approach later when the client appears ready.",
    "Evaluate for signs of pain or discomfort",
    "If client is diabetic, evaluate for low blood sugar",
    "Report changes to the client's doctor",
    "Check to make sure clothes fit appropriately and are comfortable",
    "Ask the client if they are too warm or too cold and if you can assist",
    "Try to engage client in another task",
]);

export const SUGGESTED_INSTRUCTIONS_FEAR_SUSPICIOUS = convertListToOptions([
    "Redirect into here & there now",
    "Engage in meaningful activity",
    "Explore comfort measures(warm blanket, rocking, etc.)",
    "Reassure the client that you are trying to help keep them safe",
    "Maintain consistent routines",
    "Slow down and provide a calm environment",
    "Promise to do something(such as 'I will return in two minutes') and follow through.Build on that to establish trust.",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_DELUSIONS = convertListToOptions([
    "Do not argue or discuss the delusion, other than brief acknowledgement",
    "If client is frightened or anxious, respond with reassurance",
    "Redirect to another topic or activity",
    "Additionally, notify physician of client's change of behavior",
    "Encourage the client to take medications as ordered",
    "Stay calm and tell the client you are trying to understand how they are feeling",
    "Maintain consistent routines"
]);

export const SUGGESTED_INSTRUCTIONS_HALLUCINATIONS = convertListToOptions([
    "Do not argue or discuss the hallucinations, other than brief acknowledgement. Stay calm.",
    "If client is frightened or anxious, respond with reassurance",
    "Redirect to another topic or activity",
    "Encourage the client to take medications as ordered",
    "Provide a safe environment",
    "Notify physician of client's change of behavior"
]);

export const SUGGESTED_INSTRUCTIONS_VERBAL_NOISES = convertListToOptions([
    "Try to figure out what the client is trying to communicate",
    "Look for any signs of pain / discomfort",
    "Provide comfort to the client by talking to them calmly and reassuringly",
    "Slow down and give simple directions",
    "Use calming statements",
    "Use visual / verbal clues together to aid client's understanding",
    "Offer guided choice between two options",
    "Limit stimulation",
    "Explore comfort measures(warm blanket, rocking, etc.)",
    "Gently remind client not to create rude inappropriate noises"
]);


export const SUGGESTED_INSTRUCTIONS_RESISTIVE_TO_CARE_WITH_WORD = convertListToOptions([
    "Attempt to engage the individual to take an active, positive role in their care",
    "Explain each task before initiating",
    "Offer as many choices as possible",
    "Break the task(s) down into small steps",
    "Inform the client you are going to walk away and give client alone time(listen from a distance) and return to try the task later",
    "Explore how to make interaction pleasant - ask the client what their idea is for providing care",
    "Slow down",
    "Negotiate to do the task at another time.",
    "Report changes to the client's doctor"
]);


export const SUGGESTED_INSTRUCTIONS_ASSAULTIVE_NOT_AT_PERSONAL_CARE = convertListToOptions([
    "Ensure safety of everyone involved",
    "Inform the client you are going to walk away and give client alone time.Listen from a safe distance.Re - approach later when the client appears ready.",
    "Set limits regarding abusive behavior(It's not acceptable to be abusive)",
    "Look for things that trigger behaviors and remove or minimize those triggers",
    "Allow a set amount of time / space to verbally express anger or frustration",
    "Acknowledge their feelings as they occur",
    "Decrease or increase the level of light for the client",
    "Involve the person in activities",
    "Explore comfort measures(warm blanket, rocking, etc.)",
    "Provide opportunity for physical activity",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_BREAK_THROWS_ITEMS = convertListToOptions([
    "Allow a set amount of time / space to verbally express anger or frustration",
    "Redirect to the task / situation",
    "Set limits regarding abusive behavior(It's not acceptable to break others' belongings)",
    "Ensure safety of everyone involved",
    "Inform client you are going to walk away and give client alone time.Listen from a safe distance.Re - approach later when the client appears ready.",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_WANDERS_EXIT_SEEKING = convertListToOptions([
    "Provide 'areas of interest' throughout the environment",
    "Remove safety hazards, if possible",
    "Redirect to appropriate areas of the home / residence / facility or take a walk with the client",
    "Engage in an activity",
    "Report changes to the client's doctor"
]);
export const SUGGESTED_INSTRUCTIONS_WANDERS_NOT_EXIT_SEEKING = convertListToOptions([
    "Provide 'areas of interest' throughout the environment",
    "Remove safety hazards, if possible",
    "Redirect to appropriate areas of the home / residence / facility",
    "Engage in an activity",
    "Report changes to the client's doctor"
]);
export const SUGGESTED_INSTRUCTIONS_SELF_INJURY = convertListToOptions([
    "Try to engage client in another task",
    "Encourage the client to talk about their feelings",
    "Call 911 and / or DMHP if behavior escalates to a dangerous level",
    "Report changes to the client's doctor"
]);
export const SUGGESTED_INSTRUCTIONS_SPITTING = convertListToOptions([
    "Provide a container for the client to spit in",
    "Set limits on appropriate behavior",
    "Gently remind client not to spit at others",
    "Re - direct into another activity"
]);

export const SUGGESTED_INSTRUCTIONS_SMOKING = convertListToOptions([
    "Encourage safe smoking habits",
    "Supervise smoking activity",
    "If client is on oxygen caregiver will request client turn the oxygen off during smoking",
    "Locate ashtrays near client",
    "Consult with resources to assist client in acquiring a flame retardant blanket if client smokes in bed or has history of falling asleep while smoking",
    "Provide clearly identified areas where smoking is allowed",
    "Discuss client's desire for smoking reduction / cessation and consult with resources to provide if desired",
    "Discuss and encourage client to have the caregiver hold lighter / cigarettes for safekeeping",
    "Coach client to develop a safe smoking plan"
]);

// Not found

export const SUGGESTED_INSTRUCTIONS_UNSAFE_COOKING = convertListToOptions([
    "Check burners to ensure that they are off",
    "Supervise client in and around cooking area",
    "Observe for evidence of unsafe cooking",
    "Consult with resources that may be able to assist client in acquiring safety burner covers for stovetop",
    "Prepare meals / snacks ahead not requiring the client to cook"
]);

export const SUGGESTED_INSTRUCTIONS_LEFT_HOME_LOST = convertListToOptions([
    "Accompany client on trips outside of the home",
    "Consult with resources to assist client in acquiring a bell or door alarm to alert you of when client is leaving the house",
    "Consult with resources to assist client in acquiring an ID bracelet"
]);

export const SUGGESTED_INSTRUCTIONS_LAW_BREAKING_ACTIVITIES = convertListToOptions([
    "Increase supervision of client",
    "Ensure safety of everyone involved",
    "Report incidents to APS / CRU / CPS, and / or law enforcement as applicable if the law - breaking activities are related to the abuse, neglect, or exploitation of a vulnerable adult or child",
    "Encourage client spending time around other safe persons"
]);

export const SUGGESTED_INSTRUCTIONS_SEXUAL_ACTING = convertListToOptions([
    "Set limits",
    "Provide privacy or take to a private location",
    "Report incidents to APS or CPS as required (i.e.behavior directed at children or other vulnerable adults)",
    "Report changes to the client's doctor"
]);
export const SUGGESTED_INSTRUCTIONS_EATS_NON_EDIBLE_OBJECTS = convertListToOptions([
    "Provide supervision",
    "Try to engage client in another task",
    "Offer food as an alternative",
    "Ensure that poisonous / toxic substances are kept out of client's reach",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_FIRE_SETTING = convertListToOptions([
    "Secure matches, lighters, etc.",
    "Ensure smoke detectors in home / facility are operational",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_TOILETING_MENSES = convertListToOptions([
    "Implement a toileting schedule",
    "Provide visual and / or verbal cues to direct client to appropriate places for toileting / menses activities",
    "Report changes to the client's doctor"
]);
export const SUGGESTED_INSTRUCTIONS_COMBATIVE_BEHAVIOR_AT_PERSONAL_CARE = convertListToOptions([
    "Explore how to make interaction pleasant",
    "Break tasks into small steps",
    "Slow down",
    "Negotiate to do the task at another time",
    "Explain each task before initiating",
    "Allow the person to do tasks that they are capable of doing"
]);

export const SUGGESTED_INSTRUCTIONS_HIDING_ITEMS = convertListToOptions([
    "Engage client in locating hidden items",
    "Consult with resources to assist client in finding a safe place to store items",
    "Encourage others to secure their belongings",
    "Re - direct the client to another activity",
    "Allow client to hide items as long as it does not provide a safety or health risk",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_HOARDING = convertListToOptions([
    "Set limits to behavior to ensure safe access / egress in home and to ensure fire safety",
    "Support the client in identifying waste or hazardous items in the home",
    "Promote a safe area to work with the client in their home",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_INTIMIDATING_THREATNING = convertListToOptions([
    "Allow a set amount of time / space to verbally express anger or frustration",
    "Redirect to another task",
    "Inform the client you are going to walk away and give client alone time.Listen from a safe distance.Re - approach later when the client appears ready.",
    "Set limits regarding abusive behavior(It's not acceptable to be abusive)",
    "Ensure safety of everyone involved",
    "Contact APS or CRU or CPS as applicable if the person being threatened is a vulnerable adult or child",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_TAKES_OTHER_PERSONS_ITEMS = convertListToOptions([
    "Encourage others to secure their belongings",
    "Redirect client to another activity",
    "Engage client in searching for item",
    "Provide the item they are looking for or give them an item to hang onto(stuffed animal, purse, blanket etc.)",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_SEXUAL_VIOLENCE = convertListToOptions([
    "As much as possible, keep the client away from potential victims",
    "Set limits on appropriate behavior",
    "Report changes to the client's doctor"
]);
export const SUGGESTED_INSTRUCTIONS_USES_OFFENSIVE_LANGUGAGE = convertListToOptions([
    "Speak in a calm manner to the client Explore comfort measures(warm blanket, rocking, etc)",
    "Inform the client you are going to walk away and give client alone time.Listen from another room.Re - approach later when the client appears ready.",
    "If client is unable to control the language, do not acknowledge the language and continue to provide care.",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_VERBALLY_ABUSIVE = convertListToOptions([
    "Allow a set amount of time / space to verbally express anger or frustration, (please note that this is not the same as allowing the behavior to continue without intervening).",
    "Redirect to the task",
    "Set limits regarding abusive behavior(It's not acceptable to be abusive)",
    "Inform the client you are going to walk away and give client alone time.Listen from a distance.Re - approach later when the client appears ready.",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_YELLING_SCREAMING = convertListToOptions([
    "Speak in a calm manner to ask the client to lower voice",
    "Explore comfort measures(warm blanket, rocking, etc.)",
    "Let the client know you are going to walk away and give client alone time. Listen from a distance. Re - approach later when the client appears ready.",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_OBSESSIVE_BEHAVIORS = convertListToOptions([
    "Respond calmly to the client's questions, complaints, fears etc.",
    "Provide reassurance",
    "Redirect by  providing a physical activity",
    "Provide familiar items, such as photos, furnishings, etc.",
    "Check to see whether or not the client needs to use the bathroom",
    "Offer a snack or beverage",
    "Help to redirect the client's thoughts",
    "Provide a calm, supportive, patient environment, distract as able",
    "Redirect into the here and now",
    "Report changes to the client's doctor"
]);

export const SUGGESTED_INSTRUCTIONS_REPITITIVE_BEHAVIORS = convertListToOptions([
    "Engage the client in a repetitive activity if possible Explore comfort measures(warm blanket, rocking, etc.)",
    "Report changes to the client's doctor",
    "Offer reassurance and calming environment",
    "Ask the client if they need to go to the bathroom / provide toileting assist as needed"
]);

export const SUGGESTED_INSTRUCTIONS_MANIAC_EPISODES = convertListToOptions([
    "Do not argue",
    "If client is frightened or anxious, respond with reassurance",
    "Redirect to another topic or activity",
    "Provide quiet calm environment",
    "Additionally, notify physician of client's change of behavior",
    "Encourage the client to take medications as prescribed",
    "Provide consistent routines",
    "Listen to the client"
]);

export const SUGGESTED_INSTRUCTIONS_RAPID_MOOD_SWINGS = convertListToOptions([
    "Do not argue",
    "If client is frightened or anxious, respond with reassurance",
    "Redirect to another topic or activity",
    "Provide quiet calm environment",
    "Additionally, notify physician of client's change of behavior",
    "Provide consistent routines",
    "Encourage the client to take medications as prescribed"
]);

export const SUGGESTED_INSTRUCTIONS_ACCUSE_OTHERS_STEALING = convertListToOptions([
    "Distract the client or help them look for the missing object",
    "Do not deny or confront the problem, as it will only escalate the situation",
    "Talk to the client and ask what he / she may be feeling",
    "Contact APS, the police, and / or CRU as applicable.",
    "Report changes to the client's doctor"
]);

export const DEFAULT_BODY_CHART_SECTION = {
    "carePlanType": BODY_CHART_CARE_PLAN_TYPE,
    "bodyChartMarkers": [],
    "bodyChartNotes": "",
}
